/* ══════════════════════════════════════════════════════════════════════════
 *  JOGKÖR-NÉZET × „BELÉPÉS MÁS NEVÉBEN"  ·  a tárolt jelölők egyetlen szabálya
 *
 *  A két funkció két külön localStorage-kulcson él (`cronom_jogkor_nezet`,
 *  `cronom_impersonalas`), és eddig nem tudtak egymásról. Ha az admin pl.
 *  „Adminisztrátor" jogkör-nézetben volt, majd egy tanuló nevében belépett, a
 *  nézet-jelölő ott maradt: a menü a jogkör-nézet (admin) jogkörével töltött, a
 *  fejléc is ezt küldte, a választó pedig az admin jogköreit kínálta – a tanuló
 *  nevében admin menük látszottak (Európa 2000, 2026-10).
 *
 *  A SZABÁLY: a jogkör-nézet ahhoz a KILÉTHEZ tartozik, amelyikben elindult. A jelölő
 *  ezért megjegyzi, melyik más-nevében-menetben (vagy menet nélkül, a saját fiókban)
 *  készült, és CSAK abban érvényes. A saját fiók nézete a más nevében töltött idő
 *  alatt félre van téve (a menet-jelölőben), és a visszatéréskor visszakerül – így
 *  az admin pontosan oda jut vissza, ahonnan elindult.
 *
 *  Szándékosan függőség nélküli: az interceptor, a DataService és az AppComponent is
 *  ezt olvassa, és a háromnak ugyanazt kell gondolnia arról, él-e a nézet.
 * ═══════════════════════════════════════════════════════════════════════ */

export const JOGKOR_NEZET_KULCS = 'cronom_jogkor_nezet';
export const IMPERSONALAS_KULCS = 'cronom_impersonalas';

function olvas(kulcs: string): any {
  try {
    const nyers = localStorage.getItem(kulcs);
    return nyers ? JSON.parse(nyers) : null;
  } catch (e) { return null; }
}

/** A nyitott más-nevében-menet azonosítója – vagy null, ha a saját fiókunkban vagyunk. */
export function impersonalasMenet(): string | null {
  const imp = olvas(IMPERSONALAS_KULCS);
  return imp?.menet ? String(imp.menet) : null;
}

/**
 *  A tárolt jogkör-nézet, ha az AKTUÁLIS kilétre szól – különben null.
 *
 *  A régi (mező nélküli) jelölő a saját fiókhoz tartozónak számít: frissítés után
 *  sem veszíti el senki a megnyitott nézetét, más nevében viszont nem hat.
 */
export function ervenyesJogkorNezet(): any {
  const n = olvas(JOGKOR_NEZET_KULCS);
  if (!n?.menet) return null;
  const nezetMenete = n.impersonalas ? String(n.impersonalas) : null;
  return nezetMenete === impersonalasMenet() ? n : null;
}

/** Új nézet mentése – a jelenlegi kilét (más-nevében-menet) megjegyzésével. */
export function jogkorNezetMent(menet: string, jogkor: string): void {
  localStorage.setItem(JOGKOR_NEZET_KULCS,
    JSON.stringify({ menet, jogkor, impersonalas: impersonalasMenet() }));
}

/**
 *  Más nevében belépés ELŐTT: a saját fiók nézetét félretesszük, a kulcsot kiürítjük.
 *  A visszaadott értéket a más-nevében-jelölőbe kell tenni (`sajat_jogkor_nezet`).
 */
export function sajatNezetFelretesz(): any {
  const sajat = olvas(JOGKOR_NEZET_KULCS);
  try { localStorage.removeItem(JOGKOR_NEZET_KULCS); } catch (e) { /* privát ablak */ }
  return sajat?.menet ? sajat : null;
}

/**
 *  Más nevében töltött idő VÉGÉN: a cél nevében nyitott nézet jelölője megy, a
 *  félretett saját nézet visszakerül. (A cél nevében nyitott menetet a hívó zárja le
 *  a kiszolgálón, MÉG a más-nevében-menet lezárása előtt – utána már a saját
 *  kilétünkkel kérnénk, és a menet nem a miénk.)
 */
export function sajatNezetVisszaallit(felretett: any): void {
  try {
    const most = olvas(JOGKOR_NEZET_KULCS);
    if (most?.impersonalas) localStorage.removeItem(JOGKOR_NEZET_KULCS);
    if (felretett?.menet) {
      const { impersonalas, ...sajat } = felretett;
      localStorage.setItem(JOGKOR_NEZET_KULCS, JSON.stringify(sajat));
    }
  } catch (e) { /* privát ablak */ }
}
